import React from 'react';
import HpsTable from './HpsTable';

const ProductHydroTable = ({ refreshTrigger }) => (
  <HpsTable procurementTypeHeader='1' refreshTrigger={refreshTrigger} />
);

export default React.memo(ProductHydroTable);
